import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import Cropper from 'react-cropper';
import toBlob from 'canvas-to-blob';
import { Button, Col, FormGroup, FormControl, Image, Row } from 'react-bootstrap';

import helpers from '../../lib/helpers';
import notify from '../../lib/notify';
import defaultAvatar from '../../assets/default-avatar.png';

import styles from '../../styles/variables.scss';

import { updateField, uploadProfileImage } from '../../actions/form';

const ASPECT_RATIO = (3 / 4);

export class PhotoUploadForm extends Component {
  constructor(props) {
    super(props);

    /* istanbul ignore next */
    this.state = {
      defaultImage: defaultAvatar,
      imageSrc: null,
      mime: null,
      cropBlob: null,
      cropResult: defaultAvatar,
      canSubmit: false,
      btnContent: 'No photo selected.',
    };

    this.onSrcChange = this.onSrcChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.cropImage = this.cropImage.bind(this);
    this.reset = this.reset.bind(this);
    this.onPhotoInputClick = this.onPhotoInputClick.bind(this);
  }

  onPhotoInputClick() {
    ReactDOM.findDOMNode(this.imageInput).click();
  }

  onSrcChange(e) {
    e.preventDefault();
    let files;

    if (e.dataTransfer) {
      files = e.dataTransfer.files;
    } else if (e.target) {
      files = e.target.files;
    }

    if (files.length && files[0].name) {
      const fileText = _.truncate(files[0].name, { length: 24 });
      this.setState({ btnContent: `File selected: ${fileText}  Click 'Select Photo' select another file` });
    }

    return helpers.readFileAsDataUrl(files[0])
      .then((src) => {
        const re = /data:(image\/\w+?);\w+?,(.*)/;
        const match = src.match(re);
        const mime = match[1];
        this.setState({ mime, imageSrc: src });
      })
      .catch(() => {
        notify({ type: 'error', title: 'Unable to read file' });
      });
  }

  onSubmit() {
    if (!this.state.cropBlob) return;
    const mime = this.state.mime;
    const blob = this.state.cropBlob;

    this.props.uploadProfileImage(mime, blob);
  }

  cropImage() {
    if (_.isUndefined(this.cropper.getCroppedCanvas())) return;

    if (!this.cropper.getCroppedCanvas().toBlob) toBlob.init();

    this.cropper.getCroppedCanvas().toBlob((data) => {
      this.setState({
        cropResult: this.cropper.getCroppedCanvas().toDataURL(),
        cropBlob: data,
        canSubmit: true,
      });
    });
  }

  reset() {
    const updates = {
      cropBlob: null,
      cropResult: defaultAvatar,
      canSubmit: false,
    };

    this.setState(updates, () => {
      this.cropper.reset();
      this.props.updateField('profile', 'avatar', undefined);
    });
  }

  render() {
    const disable = {
      crop: _.isEmpty(this.state.imageSrc),
      default: !_.isEmpty(this.state.cropBlob),
      submit: !this.state.canSubmit,
    };

    return (
      <React.Fragment>
        <div id="photoFormContainer" className="form-container">
          <Row>
            <Col lg={12}>
              <h3 className="form-title-span title-font-weight">Photo Upload</h3>
            </Col>
          </Row>
          <Row>
            <Col sm={2} className="thumbnail-col">
              <div className="box">
                <Image
                  id="crop-preview"
                  src={this.state.cropResult}
                  alt="preview"
                  responsive
                />
              </div>
            </Col>
            <Col sm={10}>
              <Row>
                <Col sm={12}>
                  <form id="photo-upload-form">
                    <FormGroup>
                      <Button
                        className="photoBtns"
                        label="Image File"
                        id="photoSrcPath"
                        onClick={this.onPhotoInputClick}
                      >Select Photo</Button>
                      <Button
                        className="photoBtns"
                        onClick={this.reset}
                        disabled={disable.default}
                      >Use Default</Button>
                      <Button
                        className="photoBtns"
                        onClick={this.cropImage}
                        disabled={disable.crop}
                      >Crop</Button>
                      <Button
                        className="photoBtns"
                        id="photo-submit-btn"
                        onClick={this.onSubmit}
                        disabled={disable.submit}
                      >Upload</Button>
                      <FormControl
                        type="file"
                        label="Image File"
                        id="imageInput"
                        ref={(c) => { this.imageInput = c; }}
                        onChange={this.onSrcChange}
                      />
                      <FormControl.Feedback />
                    </FormGroup>
                  </form>
                </Col>
              </Row>
              <Row>
                <Col sm={12} className="image-text-container">
                  <p className="pull-right document-text">{this.state.btnContent}</p>
                </Col>
              </Row>
              <Row>
                <Col sm={12}>
                  <div id="crop-container">
                    <Cropper
                      aspectRatio={ASPECT_RATIO}
                      guides={false}
                      dragMode="crop"
                      src={this.state.imageSrc}
                      ref={(cropper) => { this.cropper = cropper; }}
                    />
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>

        <style jsx global>{`
          #photoFormContainer {
            margin-bottom: 50px;

            #photo-upload-form > div {
              display: flex;
              margin-bottom: 0px;

              button {
                flex: 1;
                margin: 1px;
                padding: 5px;
              }
            }

            input[type="file"] {
              display: none;
            }

            .image-text-container {
              margin-top: 5px;
              color: ${styles.offwhite};
              font-size: .9em;
            }

            #crop-container {
              background: ${styles.grey};
              height: 100px;
              width: 100%;
            }
          }
        `}</style>
      </React.Fragment>
    );
  }
}

export default connect(
  null,
  { uploadProfileImage, updateField },
)(PhotoUploadForm);
